import CollectionGridBase from './CollectionGridBase';
function CollectionGrid_2_2_25_round({item }) {
  
  return(
    <CollectionGridBase rounded={true} item={item} imageWidth={25} aspectRatio={1/1} ></CollectionGridBase>
  )
}

export default CollectionGrid_2_2_25_round;